export default __webpack_public_path__ + "static/media/arrow-blue-active.a8c3f536.svg";